import productFragment from '../fragments/product';

export const getCollectionByIdQuery = /* GraphQl */ `
  query getCollection($id: ID!) {
    collection(id: $id) {
      id
      handle
      title
      description
      updatedAt
      products(first: 100) {
        nodes {
          ...product
        }
      }
    }
  }
  ${productFragment}
`;
